module.exports = __webpack_public_path__ + "static/media/licenta3.d03bcdda.png";